module.exports = __webpack_public_path__ + "img/IMG_0536-1.66861473.66861473.jpeg";